// Module
var code = "<div class=\"spreadsheet-control\"> <div class=\"spreadsheet-control-header\"> <!--ko if: IsLegendReady--> <div class=\"legend-icon\"> <i class=\"fa fa-info-circle text-info\" data-bind=\"tooltip: {content: GetLegendTemplate()}\"></i> </div> <!--/ko--> </div> <div class=\"spreadsheet-wrapper\"> <div class=\"spreadsheet\"></div> </div> </div> ";
// Exports
export default code;